module.exports = __webpack_public_path__ + "img/img-3-11.2ac49d58.webp";